// import React, { useEffect,useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useNavigate } from "react-router-dom";
// import Spinner from "react-bootstrap/Spinner";
// import { fetchStories } from "../../../../store/reducers/topStoriesSlice";
// import "./TopStories.css";
// import dummyImg from "../../../../assets/images/dummyImg.jpg"

// const TopStories = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [showSpinner, setShowSpinner] = useState(true);
//   const { stories, status, loading } = useSelector(
//     (state) => state?.fetchStories
//   );
//   useEffect(() => {
//     if (status === "idle") {
//       dispatch(fetchStories());
//     }
//   }, [status, dispatch]);
  
//   const truncateDescription = (description, wordLimit) => {
//     if (!description) return "";
//     const words = description.split(" ");
//     if (words.length <= wordLimit) return description;
//     return words.slice(0, wordLimit).join(" ") + "...";
//   };

//   const handleClick = (story) => {
//     const articleUrl = `/article/${story?._id}`;
//     navigate(articleUrl); // Navigate to the URL in the same window
//   };


//   return (
//     <div className="container">
//       <div className="top-story-section mt-5">
//         {stories?.data?.length > 0 && <h2>Top Stories</h2>}
//         <div className="top-story-grid">
//           {status === "succeeded" &&
//             stories?.data?.map((story) => (
//               <div
//                 className="top-story-box"
//                 key={story?._id}
//                 onClick={() => handleClick(story)}
//               >
//                 <div className="blog-post-images">
//                 <img
//                   src={
//                     story?.thumbnailImage
//                       ? `${process.env.REACT_APP_API_ENDPOINT_URL}/${story?.thumbnailImage}`
//                       : `${process.env.REACT_APP_API_ENDPOINT_URL}/${story?.image}`
//                   }
//                   className="story-image"
//                   alt={story?.title}
//                  />
//                    {/* <img src={dummyImg} alt="img" /> */}
//                 </div>
//                 <div className="story-section-content">
//                   <h4>{truncateDescription(story?.heading, 10)}</h4>
//                   <p>{truncateDescription(story?.description, 30)}</p>
//                   <span className="read_full_article">Read Full Article</span>
//                 </div>
//               </div>
//             ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TopStories;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { fetchStories } from "../../../../store/reducers/topStoriesSlice";
import "./TopStories.css";
import dummyImg from "../../../../assets/images/dummyImg.jpg";

const TopStories = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { stories, status, loading } = useSelector(
    (state) => state?.fetchStories
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchStories());
    }
  }, [status, dispatch]);

  const truncateDescription = (description, wordLimit) => {
    if (!description) return "";
    const words = description.split(" ");
    if (words.length <= wordLimit) return description;
    return words.slice(0, wordLimit).join(" ") + "...";
  };

  const handleClick = (story) => {
    const articleUrl = `/article/${story?._id}`;
    navigate(articleUrl); // Navigate to the URL in the same window
  };

  return (
    <div className="container Top-storycontainer-section">
      <div className="top-story-section mt-5">
        {stories?.data?.length > 0 && <h2>Top Stories</h2>}
        <div className="top-story-grid">
          {status === "succeeded" &&
            stories?.data?.map((story) => (
              <Link to={`${process.env.REACT_APP_API_ENDPOINT_URL}/stories/article/${story?.slug}`}
                className="top-story-box"
                 target="_blank" 
                  rel="noopener noreferrer"
                key={story?.slug}
                // onClick={() => handleClick(story)}
              >
                <div className="blog-post-images">
                  <img
                    src={
                      story?.thumbnailImage
                        ? `${process.env.REACT_APP_API_ENDPOINT_URL}/${story?.thumbnailImage}`
                        : `${process.env.REACT_APP_API_ENDPOINT_URL}/${story?.image}`
                    }
                    className="story-image"
                    alt={story?.title}
                  />
                  {/* <img src={dummyImg} alt="Loading..." className="placeholder-image" /> */}
                </div>
                <div className="story-section-content">
                  <h4>{truncateDescription(story?.heading, 10)}</h4>
                  <p>{truncateDescription(story?.description, 30)}</p>
                  <span className="read_full_article">Read Full Article</span>
                </div>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

export default TopStories;
